import { AuthPayload } from "@/features/auth/models/auth.models";
import AuthService from "@/services/auth.service";
import routerService from "@/services/router.service";
interface AuthState {
  authenticating: boolean;
  uuid: string;
  appSessionKey: string;
  type: string;
  token: string;
}

const state = {
  authenticating: false,
  uuid: "",
  appSessionKey: "",
  type: "",
  token: "",
};

const getters = {
  getAppSessionKey: (state: AuthState) => state.appSessionKey,
  getUuid: (state: AuthState) => state.uuid,
  isAuthenticating: (state: AuthState) => state.authenticating,
};

const actions = {
  async login(context: any, credentials: any) {
    context.commit("LOGIN");
    const payload: AuthPayload = {
      username: credentials.email,
      password: credentials.password,
      timeout: "525600",
    };

    const findOrganisationConnection = (activeConnections: any) =>
      activeConnections.find((connection: any) => connection.appType === "organisation");

    return AuthService.login(payload)
      .then((response: any) => {
        const router = routerService.getRouter();
        const uuid = response.data.uuid;
        const orgConnection = findOrganisationConnection(response.data.connections.active);
        const appSessionKey = orgConnection.appSessionKey;
        localStorage.setItem("appSessionKey", appSessionKey);
        localStorage.setItem("uuid", uuid);
        context.commit("LOGIN_SUCCESS", { appSessionKey, uuid });
        router.push("fulfilment");
      })
      .catch((error) => {
        context.dispatch(
          "application/setError",
          {
            title: `Login Error`,
            message: `Invalid credentials entered.  Please try again`,
          },
          { root: true }
        );
        context.commit("LOGIN_FAILURE");
      });
  },
  async logout(context: any) {
    context.commit("LOGOUT");
    return new Promise((resolve, reject) => {
      AuthService.logout()
        .then((response: any) => {
          context.commit("LOGOUT_SUCCESS");
          resolve(true);
        })
        .catch(() => {
          context.commit("LOGOUT_FAILURE");
          reject(true);
        });
    });
  },
  setCredentials(context: any, credentials: any) {
    context.commit("SET_CREDENTIALS", credentials);
  },
};

const mutations = {
  LOGIN(state: AuthState) {
    state.authenticating = true;
    state.appSessionKey = "";
    state.uuid = "";
  },

  LOGIN_SUCCESS(state: AuthState, payload: any) {
    const { appSessionKey, uuid } = payload;
    state.authenticating = false;
    state.appSessionKey = appSessionKey;
    state.uuid = uuid;
  },

  LOGIN_FAILURE(state: AuthState) {
    state.authenticating = false;
    state.appSessionKey = "";
    state.uuid = "";
  },

  LOGOUT(state: AuthState) {
    state.authenticating = true;
  },

  LOGOUT_SUCCESS(state: AuthState) {
    state.authenticating = false;
    state.appSessionKey = "";
    state.uuid = "";
  },

  LOGOUT_FAILURE(state: AuthState) {
    state.authenticating = false;
  },

  SET_CREDENTIALS(state: AuthState, payload: any) {
    const { type, token, appSessionKey } = payload
    state.type = type;
    state.token = token;
    state.appSessionKey = appSessionKey;
  }
};

export const auth = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
